var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:[
		{
			container: !_vm.fluid,
			'container-fluid': _vm.fluid
		}
	]},'div',_vm.$attrs,false),[(_vm.narrow)?_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-10 col-xl-8"},[_vm._t("default")],2)]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }